import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Order from "@/pages/Order";
import OrderSuccess from "@/pages/OrderSuccess";
import PrintMenu from "@/pages/PrintMenu";
import BifoldMenu from "@/pages/BifoldMenu";
import { Privacy, Terms } from "@/pages/Legal";
import { AuthProvider } from "@/admin/AuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import AuthCallback from "@/admin/AuthCallback";

// Extracted to module scope so the same object reference is reused across
// renders — avoids unnecessary <Toaster /> reconciliation work.
const TOASTER_OPTIONS = {
  style: {
    background: "#0B0B0B",
    color: "#FFFFFF",
    border: "1px solid rgba(255,255,255,0.1)",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/print-menu" element={<PrintMenu />} />
            <Route path="/print-menu/bifold" element={<BifoldMenu />} />
            <Route path="/order" element={<Order />} />
            <Route path="/order/success" element={<OrderSuccess />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/auth-callback" element={<AuthCallback />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={TOASTER_OPTIONS}
      />
    </div>
  );
}

export default App;
